import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";

function LaboratoryServices() {
  return (
    <>
      <Header />
      <section id="lab-services" className=" page p-0 m-0 gap-0">
        <div>
          {/* Header */}
          <div className="bg-light py-0 text-center">
            <h1
              className="contact-bg pt-0 text-light  text-uppercase  text-center  fw-bold col-md-12 col-lg-12 col-sm-12 "
              style={{
                fontSize: "3rem",
                letterSpacing: "3.5px",
                borderBottom: "7px solid gold",
                borderRadius: "5px",
                display: "inline-block",
                paddingBottom: "5px",
              }}
            >
              Laboratory
            </h1>
          </div>

          {/* Main Section / part 1*/}
          <div className="container my-5">
            <div className="row align-items-center g-4">
              {/* Left Content */}
              <div className="col-lg-6">
                <h2 className="fw-bold text-primary-emphasis ">
                  Get Faster, More Comfortable Laboratory Diagnostic Experience
                  at Rapid Laboratory
                </h2>

                <div
                  className="my-3"
                  style={{
                    width: "200px",
                    height: "5px",
                    backgroundColor: "gold",
                    borderRadius: "5px",
                  }}
                ></div>

                <p className="text-primary-emphasis">
                  At Rapid Laboratory, we are committed to providing you with
                  the most advanced and comfortable diagnostic experience. Our
                  state-of-the-art laboratory services are designed to deliver
                  faster results without compromising on accuracy, ensuring you
                  get the care you need when you need it.
                </p>

                <p className="text-primary-emphasis">
                  Our laboratory is equipped with the latest technology and
                  staffed by highly trained professionals who prioritize your
                  comfort and well-being. We understand that medical testing can
                  be stressful, which is why we have created a welcoming
                  environment to make your experience as pleasant as possible.
                </p>
              </div>

              {/* Right Images */}
              <div className="col-lg-6 text-center">
                <img
                  src="https://images.unsplash.com/photo-1581594693702-fbdc51b2763b"
                  alt="MRI"
                  loading="lazy"
                  className="img-fluid rounded mb-3"
                  style={{
                    maxHeight: "350px",
                    objectFit: "cover",
                    width: "100%",
                  }}
                />

                {/* Thumbnails */}
                <div className="d-flex justify-content-center gap-2">
                  <img
                    src="/images/assets/rapid-img-2.jpg"
                    alt="lab1"
                    loading="lazy"
                    className="rounded"
                    style={{
                      width: "200px",
                      height: "200px",
                      objectFit: "cover",
                    }}
                  />
                  <img
                    src="https://images.unsplash.com/photo-1579154204601-01588f351e67"
                    alt="lab2"
                    loading="lazy"
                    className="rounded"
                    style={{
                      width: "200px",
                      height: "200px",
                      objectFit: "cover",
                    }}
                  />
                  <img
                    src="images/assets/lab-img.jpg"
                    alt="lab3"
                    loading="lazy"
                    className="rounded"
                    style={{
                      width: "200px",
                      height: "200px",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Banner */}
            <div className="container my-5">
              <div
                className="d-flex flex-column flex-md-row align-items-center justify-content-between p-5"
                style={{
                  backgroundColor: "#0f5b7f",
                  borderRadius: "12px",
                }}
              >
                {/* Left Text */}
                <h2
                  className="text-white mb-4 mb-md-0"
                  style={{
                    fontSize: "32px",
                    fontWeight: "500",
                    maxWidth: "700px",
                    lineHeight: "1.4",
                  }}
                >
                  Visit Us for Your Laboratory Needs and Experience the
                  Difference in Care and Quality
                </h2>

                {/* Right Button */}
                <Link
                  className="link-underline link-underline-opacity-0 text-decoration-none"
                  to="https://www.google.com/maps/place/Rapid+Lab+and+Diagnostics+center/@5.6747617,-0.0208036,21z/data=!4m6!3m5!1s0xfdf813ca0f57087:0xef5fd0638781ba41!8m2!3d5.6748397!4d-0.0208213!16s%2Fg%2F11t6hmrfy0?entry=ttu&g_ep=EgoyMDI2MDMyMi4wIKXMDSoASAFQAw%3D%3D"
                  target="_blank"
                >
                  <button
                    className="btn text-white d-flex align-items-center gap-2"
                    style={{
                      border: "2px solid white",
                      padding: "12px 24px",
                      borderRadius: "6px",
                      fontWeight: "500",
                    }}
                  >
                    LOCATION
                    <span style={{ fontSize: "18px" }}>
                      {" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-caret-right-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                      </svg>
                    </span>
                  </button>
                </Link>
              </div>
            </div>

            {/* part 2 */}
            <div className="row align-items-center g-4 py-5 mt-5">
              {/* Left Content */}
              <div className="col-lg-6">
                <h2 className="fw-bold text-primary-emphasis ">
                  Reason For Choosing Rapid Laboratory for Your Diagnostic Needs
                </h2>

                <div
                  className="my-3"
                  style={{
                    width: "200px",
                    height: "5px",
                    backgroundColor: "gold",
                    borderRadius: "5px",
                  }}
                ></div>

                <p className="text-primary-emphasis">
                  We understand that when it comes to your health, you want the
                  best. Here are some compelling reasons why Rapid Laboratory
                  should be your top choice for diagnostic services:
                  <ul className="p-0 m-0 ">
                    <li className="list-unstyled  pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}
                        State-of-the-art equipment for accurate diagnostics
                      </span>
                    </li>

                    <li className="list-unstyled  pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}
                        Highly trained professionals prioritizing your comfort
                      </span>
                    </li>

                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}
                        Welcoming environment for a pleasant diagnostic
                        experience
                      </span>
                    </li>

                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"    "}
                        Faster turnaround times for results without compromising
                        accuracy
                      </span>
                    </li>

                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"    "}
                        Comprehensive range of laboratory tests to meet all your
                        diagnostic needs
                      </span>
                    </li>
                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"    "}
                        Commitment to patient care and satisfaction
                      </span>
                    </li>

                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"    "}
                        Convenient location and flexible scheduling options
                      </span>
                    </li>
                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"    "}
                        Affordable pricing and insurance acceptance for your
                        convenience
                      </span>
                    </li>
                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>{" "}
                      <span className="text-primary-emphasis fs-6  ">
                        {"    "}
                        Dedicated to providing you with the best possible
                        diagnostic
                      </span>
                    </li>
                  </ul>
                </p>

                <p className="text-primary-emphasis">
                  Because at Rapid Laboratory, we are not just about
                  diagnostics; we are about delivering a superior healthcare
                  experience that puts you first. Choose us for your laboratory
                  needs and experience the difference in care and quality.
                </p>
              </div>

              {/* Right Images */}
              <div className="col-lg-6 text-center">
                <img
                  src="images/assets/rapidLab-enterance.jpeg"
                  alt="rapidLabEnterance"
                  loading="lazy"
                  className="img-fluid rounded mb-3"
                  style={{
                    maxHeight: "500px",
                    objectFit: "cover",
                    width: "100%",
                    height: "100%",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default LaboratoryServices;
